<template>
  <div id="budgetCustomization">
    <div class="search-list">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="选择月份">
          <el-date-picker
            v-model="value2"
            type="month"
            placeholder="选择月"
            size="mini"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" size="mini">查询</el-button>
          <el-button type="info" @click="onSubmit" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <div class="btns">
        <el-button
          size="mini"
          @click="handleEdit(scope.$index, scope.row)"
          type="primary"
        >
          更新消耗
        </el-button>
      </div>
      <el-table
        :data="tableLists"
        row-key="id"
        border
        default-expand-all
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        style="width: 100%"
      >
        <el-table-column
          prop="date"
          label="部门"
          align="center"

          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="预算编号"
          align="center"

          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="address"
          label="预算月份"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="address"
          label="积分预算"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="address"
          label="积分分配"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="edit"
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handleEdit(scope.$index, scope.row)"
            >
              预算配置
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="dialogVisibleBudge">
      <h1>测试</h1>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive, ref, watch, getCurrentInstance, nextTick } from '@vue/composition-api'
export default {
  name: 'BudgetCustomization',
  props: [

  ],
  setup (props, ctx) {
    let tableLists = [{
      id: 1,
      date: 'KK科技公司1',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄'
    }, {
      id: 2,
      date: 'KK科技公司2',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1517 弄'
    }, {
      id: 3,
      date: 'KK科技公司3',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1519 弄',
      children: [{
        id: 31,
        date: '运营部',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        id: 32,
        date: '销售部',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }]
    }, {
      id: 4,
      date: 'KK科技公司4',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1516 弄'
    }]
    let value2 = ref('')
    let onSubmit = function () {}
    /// /
    let formInline = reactive({})
    /// 
    let dialogVisibleBudge = ref(false)
    return {
      onSubmit,
      value2,
      tableLists,
      dialogVisibleBudge,
      formInline
    }
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">

.word-nowrap-text
  white-space nowrap
  overflow: hidden
  text-overflow: ellipsis

.btns
  margin-bottom: 10px
</style>
